export function addBackslashes(str: string): string {
  return str.replace(/[.,!@%&_=/*+?^`~${}()|[\]\\#-]/g, '\\$&')
}
